import {Flex} from "@chakra-ui/react"
import {Link as RouterLink} from "react-router-dom"
import {FiArrowLeft} from "react-icons/fi"

interface BackLinkProps {
    to: string
    label: string
}

export default function BackLink({to, label}: BackLinkProps) {
    return (
        <RouterLink to={to} style={{textDecoration: "none"}}>
            <Flex
                as="span"
                alignItems="center"
                gap="6px"
                fontFamily="mono"
                fontSize="11px"
                letterSpacing="0.14em"
                color="#A3A3A3"
                textTransform="uppercase"
                fontWeight={700}
                _hover={{color: "#525252"}}
            >
                <FiArrowLeft size={13}/> {label}
            </Flex>
        </RouterLink>
    )
}
